import React from 'react'
import { connect } from "react-redux";
import { fetch, setDadosPesq } from "../actions";
import { CheckBoxPadrao } from './Base';
import { usePesq } from './Hooks/Pesq';

function ListCheckBox({ modelo, selecionado, onChange, title, ...props }) {
    const [dados, loading] = usePesq(props.fetch, props.pesq, props.setDadosPesq, modelo);

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
            <div
                style={{
                    marginTop: 5,
                }}
            >
                <p style={{ fontWeight: "bold", textAlign: "center", margin: 8 }}>
                    {title} ({selecionado.length})
          </p>
            </div>
            <div
                style={{
                    background: "#f7f7f7",
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    padding: 10,
                    marginTop: 5,
                    maxHeight: "30vh",
                    overflowY: "auto",
                    flex: 1,
                }}
            >
                {/* <pre>{JSON.stringify(selecionado, null, 2)}</pre> */}
                {(dados[modelo] || []).map((x, inx) => (
                    <CheckBoxPadrao key={x.id} checked={!!(selecionado || []).find(i => i === x.id)} onChange={v => onChange(v, x.id)} style={{ display: "block", marginLeft: inx < 1 && 8 }}>
                        {x.nome}
                    </CheckBoxPadrao>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return { pesq: state.pesq };
};

export default connect(mapStateToProps, { fetch, setDadosPesq })(ListCheckBox);

//export default ListCheckBox;